import React, { useState, useEffect } from "react";
// 引入 SCSS 样式文件
import "./Carousel.scss";

/**
 * 轮播图组件
 * @param {Array} images - 轮播图片地址数组
 * @returns {React.Element} 轮播图组件
 */
const Carousel = ({ images }) => {
  // 状态管理：当前激活的轮播索引
  const [activeIndex, setActiveIndex] = useState(0);
  // 计算图片数量（用于控制切换点显示/隐藏）
  const itemCount = Array.isArray(images) ? images.length : 0;

  // 自动轮播逻辑（单张图片时关闭自动轮播）
  useEffect(() => {
    if (itemCount <= 1) return;

    const autoPlayInterval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % itemCount);
    }, 3000);

    // 清除定时器（组件卸载/图片数量变化时）
    return () => clearInterval(autoPlayInterval);
  }, [itemCount]);

  // 点击切换点切换轮播图
  const handleDotClick = (index) => {
    if (index >= 0 && index < itemCount) {
      setActiveIndex(index);
    }
  };

  return (
    <div className='carousel-container'>
      {/* 轮播图包裹层 - 实现平滑切换 */}
      <div
        className='carousel-wrapper'
        style={{ "--carousel-offset": `-${activeIndex * 100}%` }}
      >
        {images.map((imgUrl, index) => (
          <div key={index} className='carousel-item'>
            <img
              src={imgUrl}
              alt={`carousel-item-${index}`}
              loading='lazy' // 可选：图片懒加载优化
            />
          </div>
        ))}
      </div>

      {/* 切换点容器 - 单张图片时隐藏（核心逻辑） */}
      <div
        className={`carousel-dot-container ${
          itemCount <= 1 ? "hide-when-single" : ""
        }`}
      >
        {images.map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${
              index === activeIndex ? "is-active" : ""
            }`}
            onClick={() => handleDotClick(index)}
            aria-label={`切换到第 ${index + 1} 张图片`} // 可选：无障碍访问优化
          />
        ))}
      </div>
    </div>
  );
};

// 组件默认导出
export default Carousel;
